
import React, { useEffect } from 'react';
import WOW from 'wow.js';


function AboutOne() {
    useEffect(() => {
        const wow = new WOW({
            boxClass: 'wow',      // default
            animateClass: '',     // set to empty because we use custom classes
            offset: 0,            // distance to the element when triggering the animation
            mobile: true,         // trigger animations on mobile devices
            live: true            // act on asynchronously loaded content
        });
        wow.init();
    }, []);
    return (
        <div>

            {/* rts about us section start */}
            <div className="rts-about-area rts-section-gap bg-about-sm-shape">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        {/* about left */}
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12 order-lg-1 order-md-2 order-sm-2 order-2 mt_md--50 mt_sm--50">
                            <div className="rts-title-area">
                                <p className="pre-title">À propos de nous</p>
                                <h2 className="title">Des services de qualité pour votre réussite</h2>
                            </div>
                            <div className="about-inner">
                                <p className="disc" style={{ textAlign: 'justify' }}>
                                    GLOBAL-SERVICES CONGO Sarlu, en sigle GSC Sarlu, Société de prestations de services à destination des professionnels, est présente au Congo Brazzaville, dont la direction générale est à Pointe-Noire, capitale économique ; proposant ainsi des prestations de services de qualité dans une recherche constante pour la satisfaction du client.
                                </p>
                                <p className="disc" style={{ textAlign: 'justify' }}>
                                    Quel que soit votre projet, l'entreprise GLOBAL-SERVICES CONGO Sarlu, vous accompagne, identifie l'ensemble de vos besoins et vous propose des services personnalisés répondant à vos attentes légitimes.
                                </p>
                                {/* start about success area */}
                                <div className="row about-success-wrapper">
                                    {/* left wrapper start */}
                                    <div className="col-lg-6 col-md-6">
                                        <div className="single">
                                            <i className="far fa-check" />
                                            <p className="details">Services disponibles 24h/24 et 7j/7</p>
                                        </div>
                                        <div className="single">
                                            <i className="far fa-check" />
                                            <p className="details">Consultants qualifiés et expérimentés</p>
                                        </div>
                                        <div className="single">
                                            <i className="far fa-check" />
                                            <p className="details">Équipe d'experts professionnels</p>
                                        </div>
                                    </div>
                                    {/* left wrapper end */}
                                    <div className="col-lg-6 col-md-6">
                                        <div className="single">
                                            <i className="far fa-check" />
                                            <p className="details">Accompagnement de vos activités</p>
                                        </div>
                                        <div className="single">
                                            <i className="far fa-check" />
                                            <p className="details">Solutions adaptées à vos besoins</p>
                                        </div>
                                        <div className="single">
                                            <i className="far fa-check" />
                                            <p className="details">Services personnalisés de qualité</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* about right */}
                        {/* about-right Start*/}
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1">
                            <div className="about-one-thumbnail">
                                <img
                                    src=" assets/images/about/about-img.jpeg"
                                    alt="about-finbiz"
                                    style={{ borderRadius: '8px' }}
                                />
                                <div className="experience" style={{ marginTop: '-20px' }}>
                                    <div className="left single">
                                        <h2 className="title">5+</h2>
                                        <p className="time">Années</p>
                                    </div>
                                    <div className="right single">
                                        <p className="disc">D'expérience en services de conseil</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* about-right end */}
                    </div>
                </div>
            </div>
            {/* rts about us section end */}

        </div >
    )
}

export default AboutOne